import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';

const MIN_PASSWORD_LENGTH = 8;

/** Form shape includes confirm; mutation payload is normalized via mapper. */
export type ChangePasswordFormValues = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

const changePasswordFormSchema = z
  .object({
    currentPassword: z.string().min(1, 'Current password is required.'),
    newPassword: z
      .string()
      .min(MIN_PASSWORD_LENGTH, `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`),
    confirmPassword: z.string().min(1, 'Confirm your new password.'),
  })
  .refine(value => value.newPassword === value.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
  });

export class ChangePasswordDataValidator implements Validator<ChangePasswordFormValues> {
  readonly standardSchema = changePasswordFormSchema;

  validate(value: unknown): Result<ChangePasswordFormValues, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid change-password payload.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
